import axios from "@/store/axios";
import {V1API} from "@/http/APIPath";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";
import dataMagic, {decode, encode} from "@/store/dataMagic";
import ToastificationContent from "@core/components/toastification/ToastificationContent";

const keyList = {
    hobbyUpdate : 'HOBBY_UPDATE',
    hobbyDelete : 'HOBBY_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,
    state : {
        hobby: [],
        hobbyLoading: false,
        hobbyError: false,
        submitLoading: false,
        submitError: false,
        submitSuccess: false,


        ...store
    },
    mutations : {
        ...mutations,
        SET_HOBBY (state, hobby) {
            state.hobby = hobby;
        },
        HOBBY_LOADING (state, loading) {
            state.hobbyLoading = loading;
        },
        SUBMIT_LOADING (state, loading) {
            state.submitLoading = loading;
        },
        HOBBY_ERROR(state, error) {
            state.submitError = error;
        },
        SUBMIT_ERROR (state, hasError) {
            state.submitError = hasError;
        },
        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        }
    },
    actions: {
        async updateHobby({commit, state, dispatch}, payload) {
            let response = '';
            await performNetworkCall(
                commit,
                keyList.hobbyUpdate,
                async () => {
                    let payloadData={ 
                        name: payload.name
                    }
                    let magic=encode(payloadData)
                    response = await axios.post(V1API.update_hobby+"/"+payload.id,magic.encodedPayload,magic.config).then(result => {
                        let data=decode(result.data)
                        return data
                    })

                    dispatch('fetchHobby');
                }
            )
            return response
        },



        async deleteHobby({commit, state, dispatch}, payload) {
            let response='';
            await performNetworkCall(
                commit,
                keyList.hobbyDelete,
                async () => {
                    response = await axios.delete(V1API.delete_hobby+'/'+payload).then(result=>{
                        let data=decode(result.data)
                        return data
                    });
                    dispatch('fetchHobby');
                }
            )

            return response
        },

        async fetchHobby ({ commit }) {
            commit('HOBBY_LOADING', true);
            commit('HOBBY_ERROR', false);
            try{
                let result = await axios.get(V1API.fetch_hobby);
                let response=decode(result.data.data)
                commit('SET_HOBBY', response); 

            }catch(error) {
                commit('HOBBY_ERROR', true);
            }
            commit('HOBBY_LOADING', false);
        },
        
        async addHobby({commit,dispatch}, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);
            try{
                let magic=encode(payload)
                let response = await axios.post(V1API.create_hobby,magic.encodedPayload,magic.config).then(result=>{
                    let data=decode(result.data)
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchHobby')
                return response
            }catch (e) {
                commit('SUBMIT_ERROR', true);
                return { error: true, message: e.response.data.response };
            }finally {
                commit('SUBMIT_LOADING', false);
            }
        }
    },
    getters: {}
}